import { IState } from '../store';

export const getPageData = (state: IState) => {
  return state.pageData;
};
